module.exports = __webpack_public_path__ + "r2-a450dbe9.webp";